import { createVanIconComponent } from "./van"

const FriendsOutlined = createVanIconComponent("friends-o")
export default FriendsOutlined
